var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent_div" },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c("h2", { staticClass: "hakotan_title" }, [_vm._v("送料・納期・配送")]),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [_c("dd-menu", { ref: "menuRef" }), _vm._v(" "), _vm._m(0)],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("section", { staticClass: "order_section" }, [
        _c("div", { staticClass: "order_area" }, [
          _c("div", { staticClass: "order_title" }, [_vm._v("送料について")]),
          _vm._v(" "),
          _c("div", { staticClass: "order_msg" }, [
            _vm._v(
              "\n              送料はご注文決定前に郵便番号を入力することでリアルタイムに計算され表示されますのでご確認ください。\n            "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "order_area" }, [
          _c("div", { staticClass: "order_title" }, [_vm._v("納期について")]),
          _vm._v(" "),
          _c("div", { staticClass: "order_msg" }, [
            _c("div", [
              _vm._v(
                "\n                注文を受けてから製造するお日にちをいただきます。\n              "
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "\n                詳細なお届け日はカートに追加後、購入画面より選択ください。\n              "
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "\n                ※商品によってお届け時期が異なります。\n              "
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "\n                ※ご入金状況や、土曜日・日曜日・祝日を挟む場合は、配送が遅れる場合がございます。\n              "
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "order_area" }, [
          _c("div", { staticClass: "order_title" }, [_vm._v("配送について")]),
          _vm._v(" "),
          _c("div", { staticClass: "order_msg" }, [
            _c("div", [
              _vm._v(
                "\n                玄関先までのお届けです。室内への搬入、設置は行っておりません。\n              "
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "\n                建物の状況により、玄関前ではなく建物1階でのお引渡しとなる場合がございます。\n                配達員が1人でおうかがいした場合にお届けする建物や、周囲の状況によりお客様に玄関先までの搬入を\n                お手伝いいただく場合がございます。\n              "
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "\n                ご注文の際にはあらかじめ搬入経路をご確認ください。\n              "
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "\n                搬入が不可能だった場合でのご注文後のキャンセル等はお受付できませんのでご注意ください。\n              "
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "order_area" }, [
          _c("div", { staticClass: "order_title" }, [
            _vm._v("組立設置サービスについて")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "order_msg" }, [
            _c("div", [
              _vm._v(
                "\n                ご購入いただいた家具の組立設置を、専門業者が行うサービスです。\n              "
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "\n                ※組立設置オプションには以下の費用が発生します。組立技術料：組立作業費および副資材、簡易養生材など。\n                諸経費：交通費、燃料代など。\n              "
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "\n                ※ご注文後のキャンセルはお受けいたしかねます。なお日程変更は作業予定日の3日前までにお電話にてご連絡ください。\n              "
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "order_area" }, [
          _c("div", { staticClass: "order_title" }, [
            _vm._v("■サービスの流れ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "order_msg" }, [
            _c("div", [
              _vm._v(
                "\n                ①ご注文の際に「組立設置サービス」の有無を選択いただき作業希望日を選択してください。\n              "
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "\n                ②ご注文完了後、組立業者(キャンディルグループ)より、日程調整のご連絡(メール又はお電話)をいたします。\n              "
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "\n                ③ご指定の場所におうかがいし組立設置作業をいたします。\n              "
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "\n                ④作業後は周辺を清掃、梱包材の回収を行います。\n              "
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "\n                ⑤作業終了後、ご確認&検収サインをいただき完了です。\n              "
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "order_area" }, [
          _c("div", { staticClass: "order_title" }, [
            _vm._v("■家具組立設置サービス詳細に関するお問い合わせ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "order_msg" }, [
            _c("div", [
              _vm._v("\n              【キャンディルグループ】\n              ")
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "\n                メール ： mmstyle.te@candeal.co.jp\n              "
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "\n                お電話 ： 03-5625-3095 (9:00～18:00)\n              "
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "order_area" }, [
          _c("div", { staticClass: "order_title" }, [
            _vm._v("営業時間外のご対応について")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "order_msg" }, [
            _vm._v(
              "\n              休業日や営業時間外は、基本的にメールやお電話での依頼がお受けできず、翌営業日にご対応させていただく形となっております。 できるだけ柔軟に、迅速にご対応させていただきたいと取り組んでおりますのでご理解をよろしくお願いしくお願いいたします。\n            "
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-035d0b20", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-035d0b20","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/pages/DcGuideOrder.vue
// module id = null
// module chunks = 